<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.edit') }} {{ $tc('message.affiliations', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <b-form  @reset="onReset" v-if="show">
                    <b-container>
                        <b-row>

                            <b-col sm="12">

                                <b-form-group
                                        id="patients-group"
                                        :label="$tc('message.patients', 1)"
                                        label-for="patients"
                                >
                                    <select id="patients"
                                            v-model="$v.form.patient_id.$model"
                                            required
                                            class="form-control is-invalid retirerBordure"
                                            :state="$v.form.patient_id.$dirty ? !(errorshasField('patient_id') || $v.form.patient_id.$error) : null"
                                            @focus="clearErrorField('patient_id')"
                                    >
                                        <option v-for="item in mPatients" :value="item.value" :key="item.value">
                                            {{ item.text }}
                                        </option>
                                    </select>

                                    <b-form-invalid-feedback v-if="$v.form.patient_id.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('patient_id')">
                                        {{ getErrorsField('patient_id') }}
                                    </b-form-invalid-feedback>

                                </b-form-group>

                            </b-col>

                            <b-col sm="12">
                                <b-form-group
                                        id="noms-group"
                                        :label="$t('message.name')"
                                        label-for="noms"
                                        description=""
                                >
                                    <select id="noms"
                                            v-model="form.nom"
                                            required
                                            class="form-control is-invalid retirerBordure"
                                            :state="$v.form.nom.$dirty ? !(errorshasField('nom') || $v.form.nom.$error) : null"
                                    >
                                        <option v-for="item in noms" :value="item.value" :key="item.value">
                                            {{ item.text }}
                                        </option>
                                    </select>

                                    <b-form-invalid-feedback v-if="$v.form.nom.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('nom')">
                                        {{ getErrorsField('nom') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="12">
                                <b-form-group
                                        id="start-date-group"
                                        :label="$t('message.startDate')"
                                        label-for="start-date">
                                    <b-form-input
                                            id="start-date"
                                            v-model="form.date_debut"
                                            :state="$v.form.date_debut.$dirty ? !(errorshasField('date_debut') || $v.form.date_debut.$error) : null"
                                            type="date"
                                            placeholder=""
                                            @focus="clearErrorField('date_debut')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('date_debut')">
                                        {{ getErrorsField('date_debut') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="$v.form.date_debut.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>


<!--                            <b-col sm="12">-->
<!--                                <b-form-group-->
<!--                                        id="end-date-group"-->
<!--                                        :label="$t('message.endDate')"-->
<!--                                        label-for="end-date">-->
<!--                                    <b-form-input-->
<!--                                            id="end-date"-->
<!--                                            v-model="form.date_fin"-->
<!--                                            :state="$v.form.date_fin.$dirty ? !(errorshasField('date_fin') || $v.form.date_fin.$error) : null"-->
<!--                                            type="date"-->
<!--                                            placeholder=""-->
<!--                                            @focus="clearErrorField('date_fin')"-->
<!--                                    ></b-form-input>-->

<!--                                    <b-form-invalid-feedback v-if="errorshasField('date_fin')">-->
<!--                                        {{ getErrorsField('date_fin') }}-->
<!--                                    </b-form-invalid-feedback>-->
<!--                                </b-form-group>-->
<!--                            </b-col>-->
                        </b-row>

                        <b-row class="justify-content-sm-center">
                            <b-button @click="onSubmit" variant="primary">
                                {{ $t('message.edit') }}
                            </b-button>

<!--                            <b-button type="reset" variant="danger">-->
<!--                                {{ $t('message.reset') }}-->
<!--                            </b-button>-->
                        </b-row>
                    </b-container>


                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { required } from 'vuelidate/lib/validators';
    import _ from 'lodash';
    import SlimSelect from 'slim-select';

    export default {
        name: "EditAffiliation",

        computed: {
            ...mapGetters(["affiliation", "patients", "errors"]),

            form: function() {
                return this.affiliation;
            },

            mPatients: function() {
                let pArray = [];

                _.forEach(this.patients, function(patient) {
                    if (typeof patient.user == 'object'){
                        let user = patient.user;
                        if (typeof patient.dossier == "object"){
                            let dossier  = patient.dossier;
                            let prenom = (user.prenom != null && user.prenom) ?  user.prenom : '' ;
                            prenom = prenom.toLowerCase();
                            let text = (user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1)+" "+ "("+ dossier.numero_dossier +")";
                            pArray.push({text: text, value: patient.user_id });
                        }
                    }
                });

                return pArray;
            },
        },

        data() {
            return {
                affiliation_id: this.$route.params.affiliation,
                noms: [
                    { text: 'One shot', value: 'One shot' },
                    { text: 'Annuelle', value: 'Annuelle' }
                ],
                show: true,
                offset: 0,
                limit: -1,
            }
        },

        methods: {
            getUserAffiliation: function() {
                let args = {
                    affiliation: this.affiliation_id,
                    offset: this.offset,
                    limit: this.limit
                };
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getAffiliation', { args, errorMessages });
            },

            getPatients: function() {
                this.$store.dispatch('getPatients', { args: {} });
            },

            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();

                if(!this.$v.$invalid) {
                    let args = {
                        affiliation: this.affiliation_id,
                        patient_id: this.form.patient_id,
                        nom: this.form.nom,
                        date_debut: this.form.date_debut,
                        // date_fin: this.form.date_fin
                    };

                    let successMessage = this.$i18n.t('message.affiliationUpdated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('updateAffiliation', { args, errorMessages, successMessage })
                        .then(() => {
                            // Scroll to the top of the page
                            document.body.scrollTop = 0; // For Safari
                            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                        });
                }
            },

            onReset: function(evt) {
                /*evt.preventDefault();

                // Reset our form values
                this.form.patient_id = null;
                this.form.nom = '';
                this.form.date_debut = null;
                this.form.date_fin = null;

                // Trick to reset/clear native browser form validation state
                this.show = false;

                this.$nextTick(() => {
                    this.show = true;
                });*/
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            }
        },

        validations: {
            form: {
                patient_id: {
                    required
                },
                nom: {
                    required
                },
                date_debut: {
                    required
                },
                // date_fin: {
                //     //
                // }
            }
        },

        mounted() {
            // Retrieve affiliation
            this.getUserAffiliation();

            // Récupérer les patients
            this.getPatients();

            new SlimSelect({
                select: '#noms',
                placeholder: 'Select types'
            });
            new SlimSelect({
                select: '#patients',
                placeholder: 'Select patient'
            })
        }
    }
</script>

<style scoped>
    @import url('~slim-select/dist/slimselect.min.css');
</style>